const or = {
  // af.js – Afaan Oromoo translations (from your table)
  all: "Hunda",
  pending: "adeemsarra jiraachuu",
  underInvestigation: "qoratamaa jira",
  draftCharge: "Draft Charge",
  underLitigation: "Falmiirra jira",
  closed: "Cufameera",
  accusedProsecutor: "abbaa alangaa himatame",
  assignedTo: "Abbaa hirameef",
  appliedDate: "guyyaa iyyatame",
  status: "Sadarkaa",
  phoneNumber: "Lakkoofsa bilbilaa",
  assign: "qooduu",
  assigned: "Qoodameera",
  action: "sadarkaa himannaan irra jiru",
  open: "Banaa",
  pageTitle: "Komii balleessaa naamusaa dhiyeessuu",
  addNewComplaint: "komii yookiin eeruu haaraa dabaluu",
  tableTitle: "gabatee gaaffii tajaajilaa",
  complaintFormTitle: "Komii",
  complaintFormSubtitle: "Tarreewwan armaan gadii sirnaan guuti",
  selectAccusedProsecutor: "abbaa alangaa himatame filachuu",
  searchAccusedProsecutor: "abbaa alangaa himatame maqaan barbaadi",
  woreda: "Woordaa",
  zone: "Zoonii",
  accusedProsecutorPhone: "bilbila abbaa alangaa himatamee",
  gender: "koorniyaa",
  jobStatus: "sadarka hojii",
  receptionDate: "Guyyaa eeruun fuudhame",
  dateOfOffense: "Guyyaa balleessan naamuusaa raawwatame",
  disciplinaryOffenseType: "Gosa balleessaa naamuusa",
  selectOffenseType: "gosa balleessaa filachuu",
  offenseDescription: "ibsa balleessaa naamuusaa",
  describeIncident: "Gocha taatee raawwatame ibsuu",
  addComplaint: "komii yookiin eeruu haaraa dabaluu",
  male: "dhiira",
  female: "dubartii",
  submissionError: "dogongora galchuu irratti uumamu",
  successfullyCreated: "milkaa'inaan uumamee jira.",
  successfullyUpdated: "milkaa'inaan fooyya'e",
  successfullyConfirmed: "milkaa'inaan simatameera",
  graveOffenseError:
    "balleessan naamuusaa cimaan waggaa 4 keessatti eeruun kennamu qaba",
  mediumOffenseError:
    "Balleessaan naamusa giddugaleessaa raawwatame waggaa 3 keessatti dhiyaachuu qaba.",
  pityOffenseError:
    "balleessan naamuusaa salphaa erga raawwatame kaasee waggaa 2 keessatti dhiyaachuu qaba.",
  dateRequired: "Guyyaan barbaachisaadha ykn sirrii miti.",
  submitting: "galchuu",
  prosecutorOffenceRegion: "Balleessaa naamuusaa abbaa alangaa Naannoo",
  prosecutorOffenceZone: "Balleessaa Naamuusaa abbaa alangaa Godinaa",
  prosecutorOffenceWoreda: "Balleessaa naamuusaa abbaa alangaa Aanaa",
  complaintDetail: "Komii yookiin eeruun dhiyaate bal'inaan",
  detailInformation: "Odeefannoo bal'inaa",
  litigation: "falmii",
  appeal: "ol'iyyannoo",
  uploadChargeDocument: "Sanada Kaffaltii Olkaa'uu",
  sendToRegistrar: "gara mana galmee erguu",
  sendToCouncilOffice: "Gara Waajjira Gumiitti erguu",
  sendToCouncilHead: "Gara Itti Gaafatamaa Waajjira Gumiitti erguu",
  sendToRegionalCouncilHead:
    "Gara Itti Gaafatamaa Waajjira Gumii Naannootti erguu",
  sendToZonalCouncilHead:
    "Gara Itti Gaafatamaa Waajjira Gumii Godinaatti erguu",
  backToProsecutor: "Gara abbaa alangaatti deebisuu",
  backToCouncilOfficer: "Gara Daarektooreetii Inispeekshiniitti deebisuu",
  approvedToCreateLetter: "Approve To Create Summon",
  createASummon: "Waamicha Uumuu",
  terminate: "adda kutuu",
  addInitialHearing: "Dhageettii duraa danbali",
  addDailyHearing: "dhagaha falmii guyyaa guyyaa dabaluu",
  addLitigationDecision: "falmii ol'iyyannoo dabaluu",
  addCouncilOfficeDecision: "murtii Gumii dabaluu",
  createAccusedAppeal: "Ol’iyyannoo Himatamaa Uumuu",
  updateAppeal: "Iyyannoo Fooyyessi",
  requestForAppeal: "ol'iyyannoof gaafachuu",
  appealRequest: "ol'iyyannoo gaafachuu",
  sent: "ergame",
  failedToLoadComplaint: "Eeruuwwan fiduu hin dandeenye",
  failedToLoadInvestigation: "galmee qorannaa fe'uu hin dandeenye",
  failedToLoadSummon: "waraqaa waamichaa fiduu hin dandeenye",
  failedToLoadLitigation: "Falmii fe'uu hin dandeenye",
  failedToLoadCouncilLitigation: "falmii Gumii fe'uu hin dandeenye",
  failedToLoadAppeal: "ol'iyyannoo fe'uu hin dandeenye",
  failedToLoadAccusedSummon: "Waamicha himatamaa fe’uu hin dandeenye",
  investigationNotFound: "Qorannoon kan hin argamne",
  offenseType: "gosa balleessaa naamuusaa",
  terminationReason: "sababa adda cittinsaa",
  orderGivenBy: "Ajaja Kenneef",
  terminationDoc: "Ragaa ykn Dokuimantii adda cite",
  documentInformation: "Odeefannoo dookumention/Odeeffannoo Ragaa",
  receivedBy: "Received by",
  registeredBy: "Kan galmaa'e",
  decisionType: "Gosa Murtii Mana Murtii",
  decisionDay: "Guyyaa murtii",
  decisionSummary: "Cuunfaa murtii Mana Murtii",
  evidenceInfo: "Odeefannoo ragaa",
  assignedDate: "guyyaa qoodameef",
  publicProsecutorDecision: "Public Prosecutor Decision",
  unassigned: "Unassigned",
  reassignCase: "Reassign Case",
  prosecutorDecision: "Prosecutor Decision",
  noDate: "No date",
  furtherInvestigation: "Further Investigation",
  prosecutorDecisionDocument: "murtii abbaa alangaa",
  feedbackType: "gosa duubdeebii",
  hideFeedbacks: "duubdeebii dhoksuu",
  showAllFeedbacks: "duubdeebii hunda agarsiisi",
  addFeedback: "duubdeebii dabaluu",
  addFurtherInvestigation: "Further Investigation dabaluu",
  addDecision: "murtii kenname dabali",
  chargeDocument: "Galmee himannaa",
  registeredDate: "Guyyaa galmee",
  registeredNumber: "lakkoofsa galmee",
  chargeSummary: "Cuunfaa himannaa",
  articleOfCharge: "keewwata himataa",
  chargeDoc: "Sanada himannaa",
  chargeFeedback: "Duubdeebii himannaa irratti kennamu",
  councilChargeFeedback: "duubdeebii Gumiin himannaa irratti kennamu",
  addRegistrationNo: "lakkoofsa galmee dabaluu",
  updateChargeDoc: "Kaffaltii Fooyyessi Doc",
  summon: "waraqaa waamichaa",
  hearingDate: "guyyaa dhagahaa falmii",
  addressInformation: "odeefannoo bakka argamsaa",
  summary: "cuunfaa",
  summonDoc: "Waamicha Dok",
  confirm: "Mirkaneessuu",
  accusedProsecutorResponse: "deebii abbaa alangaa himatamee",
  letterDoc: "Letter Doc",
  addResponse: "deebii dabaluu",
  dailyReportSummary: "Cuunfaa Gabaasa Guyyaa Guyyaa",
  appointmentReason: "sababa beellamaa",
  attendances: "dhiyaachuu",
  member: "Miseensa",
  present: "jira",
  yes: "Eeyyee",
  no: "No",
  date: "Guyyaa",
  remark: "Remark",
  councilDecisionSummary: "Cuunfaa murtii Gumii",
  minuteFile: "Faayila Daqiiqaa",
  councilDecisionFile: "Galmee murtii Gumii",
  terminationFile: "faayila adda cittinsaa",
  addAttendance: "qaaman argamuu",
  officeOfCouncilDecision: "Office of Council Decision",
  submissionDate: "guyyaa galfamu",
  councilDecisionType: "Gosa murtii Gumiin kenname",
  decisionMeasureType: "Gosa safartuu murtii",
  councilOrder: "Ajaja Gumii",
  wasPresent: "Argameera",
  nextAppointmentDate: "guyyaa beellamaa itti aanu",
  remainingDaysForAppeal: "guyyoota ol'iyyannoof hafe",
  day: "Guyyaa",
  days: "Guyyootaa",
  prosecutorOpinionOnDecision:
    "yaada abbaa alangaa murtii kenname irratti kennamu",
  feedback: "duubdeebii",
  prosecutorOpinion: "yaada abbaa alangaa",
  memorandumSummary: "cuunfaa komii ol'iyyannoo naamuusaa",
  memorandumDoc: "komii ol'iyyannoo naamuusaa",
  appealType: "Gosa ol'iyyannoo",
  feedbackOnMemorandum: "komii ol'iyyataa irratti duubdeebii kennamu",
  addFeedbackOnMemorandum: "komii qophaa'e irratti duubdeebii kenname dabaluu",
  activityLogs: "Galmeewwan Gochaalee",
  changedBy: "Jijjiirramuu",
  actionType: "himannaa balleessaa naamuusaa",
  fieldName: "kutaa hojii",
  oldValue: "Old Value",
  newValue: "Gatii haaraa",
  additionalInfo: "odeefannoo dabalataa",
  modelName: "Model Name",
  applicationNumber: "Application Number",
  accusedComplaintRequests: "Iyyannoo himatamaa bal'inaan",
  serviceRequestTable: "gabatee gaaffii tajaajilaa",
  appealToGeneralCouncil: "Apepal to General Council",
  generalCouncilLitigation: "General Council Litigation",
  accusedComplaintDetail: "Iyyannoo himatamaa bal’inaan",
  sendToCouncil: "Gara Waajjira Gumiitti erguu",
  addAppealLitigationDecision: "falmii ol'iyyannoo dabaluu",
  appealToCourt: "Mana Murtiitti ol'iyyachuu",
  summonNotFound: "Waamichi hin argamne!",
  appealToCouncil: "Apepal to Council",
  councilLitigation: "Falmii ol'iyyata irratti gaggeeffamu",
  accusedSummon: "Abbaa Alangaa himatameef xalayaa waamichaa erguu",
  registrationNumber: "Lakkoofsa galmee",
  registrationDate: "Guyyaa Galmee",
  claimSummary: "Cuunfaa dhimmaa dhiyaatee",
  claimSummaryDoc: "Sanada Cuunfaa komii",
  letterUpload: "Letter Upload",
  responseSummary: "cuunfaa deebii",
  assignProsecutor: "abbaa alangaa ramaduu",
  confirmed: "Mirknaa'e",
  confirmAccusedSummon: "Waamicha Himatamaa Mirkaneessuu",
  selectProsecutor: "abbaa alangaa filachuu",
  cannotFindSummon: "Waamichi argachuu hin dandeenye",
  canNotFindSummonOrAppealData:
    "Ragaa waamichaa ykn ol'iyyannoo argachuu hin dandeenye",
  noPermissionCreateDailyHearing:
    "Guyyaa guyyaan dhageettii uumuuf hayyama hin qabdu",
  addAccusedAppealDailyHearing:
    "Ol’iyyannoo Himatamaa Dabaluu Dhaddacha Guyyaa Guyyaa",
  datePlaceholder: "Fkn. June 12, 2014",
  givenOrder: "ajaja kenname",
  detailsPlaceholder: "Tarreeffama isaa",
  uploadFiles: "Faayilota Olkaa'uu",
  addSummonRegistrationNo: "lakkoofsa waraqaa waamichaa dabaluu",
  registrationNo: "lakkofsa galmee",
  registrationPlaceholder: "Fkn. XX000001 irratti kan argamu",
  submit: "galchuu",
  accusedSummonNotFound: "Waamichi himatamaa hin dhaqqabne",
  responseFile: "Faayilii deebii",
  complaintNotFound: "Komii hin argamne",
  courtName: "Guyyaa dhagaha mana murtii",
  courtNumber: "Maqaa mana murtii",
  hearingCourt: "Mana murtii falmii dhaga'u",
  courtOrderSummon: "Waamicha Mana Murtii",
  courtSummonFile: "Galmee Waamicha Mana Murtii",
  accusedAdvocate: "Abukaatoo himatame",
  licenseNumber: "lakkoofsa hayyamaa",
  emDash: "—",
  accusedAdvocateComplaintRequests: "Tarree deebii abukaatoo himatamee",
  accused: "Himatamaa balleessaa naamuusaa",
  advocate: "Abukaatoo",
  paralegal: "Paralegal",
  evidence: "Ragaa",
  reporter: "eeruu kennitoota",
  victim: "Miidhaamtoota",
  witness: "Dhugaa Baatota",
  assignedProsecutor: "abbaa alangaa ramadame",
  hearingInformation: "odeefannoo dhagaha dhimmaa",
  noClaimSummaryAvailable: "Cuunfaan himannaa hin jiru",
  documents: "Gosa dokumentiiwwanii",
  responseDocument: "dokumentii deebii",
  createSummon: "Waamicha Uumuu",
  reassignProsecutor: "Reassign Prosecutor",
  previouslyAssignedProsecutor: "abbaa alangaa duraan ramadamee ture.",
  name: "maqaa",
  userId: "ID fayyadamaa",
  verbalLitigation: "Falmii Afaaniin",
  evidenceInspection: "ragaa inispeekshinii",
  evidenceDefence: "evidence defence",
  finalDecision: "murtii dhumaa",
  createAccusedSummon: "Waamicha Himatamaa uumuu",
  hearingDatePlaceholder: "Fkn. June 12, 2014",
  detailsHere: "Tarreeffama isaa",
  advocateAppealRequests: "Gaaffii Ol’iyyannoo Abukaatoo",
  councilAppeal: "Gumii ol'iyyata ilaalu.",
  councilAppealLitigation: "Falmii ol'iyyata irratti gaggeeffamu",
  courtAppeal: "Gara Mana Murtii Ol'iyyachuu",
  courtAppealLitigation: "Falmii ol'iyyannoo mana murtiitti gaggeeffamu",
  appealDetail: "Tarree komii ol'iyyannoo gara mana murtii",
  rejectAppeal: "ol'iyyannoo fudhatama dhabe",
  createAppealSummon: "Waamicha Ol’iyyannoo Uumuu",
  appealNotFound: "Appeal not found!",
  forwardedToRegistrar: "gara mana galmee dabarsuu",
  forwardedToCouncil: "gara Gumii dabarsuu",
  generalCouncilAppeal: "General Council Appeal",
  generalCouncilAppealLitigation: "General Council Appeal Litigation",
  createGeneralCouncilAppealSummon: "Create General Council Appeal Summon",
  addCouncilDecision: "Murtii Gumii dabaluu",
  councilDecisionDate: "Guyyaa Gumiin Murtii kenne",
  egJune122014: "Fkn. June 12, 2014",
  selectDisciplineType: "gosa balleessaa naamuusaa filachuu",
  addAppealDailyHearing: "dhagaha ol'iyyannoo dabaluu",
  dailyHearingHistory: "Seenaan dhageettii guyyaa guyyaa",
  noDailyHearingHistoryFound: "Seenaan dhageettii guyyaa guyyaa hin argamne!",
  youDoNotHavePermissionToCreateDailyHearing:
    "Guyyaa guyyaan dhageettii uumuuf hayyama hin qabdu",
  addCourtDecision: "murtii mana murtii dabaluu",
  prosecutorOpinionOnAppeal: "yaada abbaa alangaa ol'iyyannoo irratti kennamu",
  courtDecisionDate: "Guyyaa Murtii Mana Murtii",
  courtDecisionType: "Gosa Murtii Mana Murtii",
  selectDisciplineMeasure: "tarkaanfii naamuusaa filachuu",
  courtDecisionFile: "Galmee Murtii Mana Murtii",
  addAppealSummonDecision: "murtii ol'iyyannoo irratti kenname dabaluu",
  decisionFile: "Faayila Murtii argate",
  region: "Naannoo",
  kebele: "Ganda",
  summonFile: "Faayila Waamichaa",
  addSummon: "waraqaa waamichaa dabaluu",
  uploadMemorandumOfDisciplinaryAppeal: "Upload Yaadannoo Iyyannoo Naamusaa",
  appealFromInspectionProsecutorToCouncilOffice:
    "ol'iyyannoo abbaa alangaa Inispeekshinii",
  appealFromInspectionProsecutorToCourt:
    "ol'iyyaannoo abbaan alangaa Inispeekshinii gara mana murtiitti gaafatu",
  amendedMemorandumOfDisciplinaryAppealSummary:
    "Komii ol'iyyannoo dhimma balleessaa naamuusaa fooyya'e",
  amendedMemorandumOfDisciplinaryAppealDoc:
    "Yaadannoo Ol’iyyannoo Naamusaa Fooyya’e Dok",
  uploadMemorandum: "Yaadannoo Olkaa'uu",
  compliantNotFound: "Komii Hin argamne",
  memorandumFileIsRequired: "Faayilli yaadannoo barbaachisa",
  addChargeFeedback: "duubdeebii himannaa irratti kenname dabaluu",
  expired: "Kan yeroon irra darbe",
  ago: "Guyyaa/Guyyoota irra darbame",
  dueToday: "Har'a xumuurama",
  dueTomorrow: "Boru xumuuram",
  remaining: "kan hafe",
  appealDecision: "murtii ol'iyyannoo irratti Gumiin kennamu",
  appealCouncilDecision: "murtii ol'iyyannoo irratti Gumiin kennamu",
  finalDecisionRendered: "Gumii ol'iyyata ilaaluun murtii dhumaa kenname",
  decisionDate: "Guyyaa murtii",
  measureType: "gosa tarkaanfii",
  appealDeadlineStatus: "guyyaa ol'iyyannoon keessatti gaafatamu",
  deadline: "Guyyaa xumuraa",
  advocateClaimSummary: "Cuunfaa Himata Abukaatoo",
  decisionDocuments: "Dokumantiiwwan murtii",
  appealHearingSession: "guyyaa ol'iyyannoon itti dhaga'amu",
  decisionMade: "Murtii kenname",
  nextHearing: "guyyaa dhagahaa itti aanu",
  hearingDecisionSummary: "dhagaha cuunfaa murtii",
  hearingDocuments: "Sanada dhagahamu",
  officialDecisionDocument: "Dokumatii ofishaalaa",
  caseTerminationDocument: "Ragaa dhimmichi itti naddaan citee",
  noAppealLitigationData: "Daataa Falmii Ol’iyyannoo Hin Qabu",
  noAppealLitigationMessage:
    "There are no appeal decisions or hearing records available for this case.",
  accusedResponse: "Accused Response",
  confirmAppealSummon: "Waamicha ol'iyyannoo mirkaneessuu",
  summonConfirmedBy: "Waamichi Mirkanaa'e By",
  coordinator: "Qindeessaa",
  rejectComment: "yaada fudhatama dhabe",
  showDailyHearingHistory: "dhagaha guyyaa guyyaab gaggeeffamu agarsiisi",
  institution: "dhaabbata",
  noPermissionToCreateDailyHearing:
    "Guyyaa guyyaan dhageettii uumuuf hayyama hin qabdu",
  noPermissionToTerminate: "Guyyaa guyyaan dhageettii uumuuf hayyama hin qabdu",
  terminateLitigation: "falmii adda kutuu",
  advocateComplaintReceptionRequests: "Gaaffii Simannaa Komii Abukaatoo",
  failedToLoadAdvocates: "Abukaatoon wal simu hin argamne",
  failedToLoadDecisionTypes: "Failed to load decision types",
  failedToLoadMeasureTypes: "Failed to load measure types",
  receptionDateRequired: "Reception Date is Required.",
  offenseDateRequired: "Date of Offense is Required.",
  accusedAdvocateRequired: "Accused Advocate is Required.",
  pettyOffenseError:
    "balleessan naamuusaa salphaa erga raawwatame kaasee waggaa 2 keessatti dhiyaachuu qaba.",
  newAdvocateComplaintRegistration: "Galmee komii abukaatota",
  officialFormDescription:
    "Unka ofiisaa komii naamusaa abukaatoota irratti galmeessuuf oolu. Dirreewwan mallattoo kanaan agarsiifaman hunda guutuun dirqama.",
  areMandatory: "are mandatory",
  advocateInformation: "Advocate Information",
  advocateInformationDescription:
    "Abukaatoo himatame filachuu fi cabiinsa ogummaa mul'ate dhiyeessuu",
  accusedAdvocateDescription:
    "Abukaatoo seeraa komiin irratti dhiyaate adda baasi.",
  isAccusationReportByMobile: "Is Accusation report By mobile?",
  accusationReportByMobileDescription:
    "Komiin kun appii moobaayilii irratti dhiyaate ta'uu isaa mirkaneessi.",
  reportApplicationNumber: "Report Application Number",
  reportApplicationNumberDescription:
    "Lakkoofsa wabii/galmee eeruu ykn iyyannoo galchi.",
  reportApplicationNumberPlaceholder: "e.g., APP-2024-00123",
  complaintType: "Complaint Type",
  advocateComplaint: "Advocate Complaint",
  paralegalComplaint: "Paralegal Complaint",
  complaintTypeDescription:
    "Komiin kun abukaatoo irratti moo paraaleegaalii irratti akka ta'e filadhu.",
  searchAdvocate: "Abukaatoo himatame filachuu",
  searchAdvocateDescription: "Maqaa yookiin lakkoofsa hayyamaa galchi",
  searchAdvocatePlaceholder: "Enter advocate name or license number...",
  searchingAdvocateRegistry: "Searching advocate registry...",
  license: "Hayyama",
  na: "N/A",
  noAdvocatesFound: "Abukaatoon wal simu hin argamne",
  legalAdvocate: "Abukaatoo seeraa",
  phone: "Phone",
  caseDetails: "Dhimma dhiyaate bal'inaan",
  caseDetailsDescription: "waa'ee eeruu naamuusaa dhiyaate bal'inaan ibsuu",
  basicInformation: "Odeefannoo bu'uuraa",
  selectClassification: "gosa adda baasuun filachuu",
  complaintReceptionDate: "Guyyaa eeruun fuudhame",
  dateOfAllegedOffense: "Guyyaa Yakka Himatame",
  fieldRequired: "Gosti kun barbachisaadha/marbadamaadha",
  detailedOffenseDescription: "Ibsa badii naamuusaa bal'inaan",
  offenseDescriptionPlaceholder:
    "eeruu balleessa namuusaa dhiyaate, eessatti, eenyuun, guyyaa raawwate fi gosa isaa ragaadhan deeggaranii dhiyeessuu",
  characters: "Amala",
  returnToDashboard: "Gara Daash borditti deebi'uu",
  clearAllFields: "Akaakuu hundaa balleessi/haqi",
  processingSubmission: "Dhiyeessii gaggeessuu",
  submitAdvocateComplaint: "Komii Abukaatoo dhiyeessuu",
  issueASummon: "waraqaa waamichaa qopheessuu",
  reporters: "eeruu kennitoota",
  victims: "Miidhaamtoota",
  witnesses: "Dhugaa Baatota",
  summonIssued: "Waamichi Bahe",
  hide: "Hide",
  show: "Show",
  approved: "cime",
  claimSummaryFile: "Faayila Cuunfaa komii",
  addAccusedSummon: "waraqaa waamichaa himatamaa dabaluu",
  addMemorandumFeedback: "Add Memorandum Feedback",
  memorandumFileRequired: "Faayilli yaadannoo barbaachisa",
  appealFromInspectionToCouncil: "ol'iyyannoo abbaa alangaa Inispeekshinii",
  appealFromInspectionToCourt:
    "ol'iyyaannoo abbaan alangaa Inispeekshinii gara mana murtiitti gaafatu",
  memorandumDocument: "komii ol'iyyannoo naamuusaa",
  somethingWentWrong: "Something went wrong.",
  addAppealRegistrationNo: "Add Appeal Registration No.",
  provideChargeSummary: "cuunfaa himataa dhiyeessuu",
  provideArticleOfCharge: "keewwata himannaa balleessaa naamuusa dhiyeessuu",
  chargeDocumentFramed: "Himannaa qulqullinaan baname dhiyaate",
  failedToFrameCharge: "Dokumantii/ragaa/ hin himachiifne",
  frameChargeDocument: "himannaa dhiyeessuu yookiin banuu",
  framingCharges: "himannaa qopheessuu",
  case: "Case",
  chargeSummaryPlaceholder: "Cuunfaa himannaa",
  articleOfChargePlaceholder:
    "Kewwata seeraa fi seera cabsee ittiin himatamuuf deemu",
  clickToChange: "Click to change",
  clickToUploadOrDrag: "Fe'uuf cuqaasuu",
  fileTypes: "PDF, DOC, DOCX up to 10MB",
  removeFile: "Remove File",
  cancel: "Haquu",
  addChargeRegistrationNo: "Add Charge Registration No.",
  prosecutorRequired: "Prosecutor is required",
  decisionCreated: "Decision successfully created",
  forwardToZone: "Forward to Zone",
  selectZone: "Godina filachuu",
  decisionSummaryPlaceholder: "Provide details about your decision...",
  processing: "Processing...",
  summonInformationNotFound: "Summon information not found",
  dailyHearingOfficiallyDocumented:
    "Daily hearing record has been officially documented",
  failedToDocumentDailyHearing: "Failed to document daily hearing",
  inspectionOfficeDailyHearing: "Inspection Office Daily Hearing",
  councilOfficeDailyHearing: "Council Office Daily Hearing",
  dailyHearingRecord: "Daily Hearing Record",
  hearingDetails: "Hearing Details",
  mustBeAfterTheHearingDate: "Must be after the hearing date",
  councilOrderInstruction: "Council Order/Instruction",
  enterOfficialCouncilOrdersOrInstructions:
    "Enter official council orders or instructions...",
  selectAppointmentReason: "Select appointment reason",
  finalHearingDecisionWarning:
    "This will be recorded as the final hearing decision",
  provideOfficialSummaryOfTodayProceedings:
    "Provide the official summary of today's proceedings...",
  minuteDocumentation: "Minute Documentation",
  uploadMeetingMinutes: "Upload Meeting Minutes",
  uploadOfficialMinutes: "Upload Official Minutes",
  documentHearing: "Document Hearing",
  dailyHearingRecordWillBeOfficiallyDocumented:
    "This hearing record will be officially documented in the litigation proceedings.",
  finalHearingDecisionConfirmation: "Final Hearing Decision Confirmation",
  finalHearingDecisionConfirmationMessage:
    "You are about to record this as the final hearing decision. This will conclude the litigation proceedings. Are you sure you want to proceed?",
  recordFinalDecision: "Yes, Record Final Decision",
  goBack: "No, Go Back",
  prosecutorDecisionRegistry: "Prosecutor Decision Registry",
  decisionDetails: "Decision Details",
  selectDecisionType: "Select decision type",
  outOfJurisdictionForwardToZone: "Out of jurisdiction forward to zone",
  forwardedToZoneForFurtherInvestigation:
    "Forwarded to zone for further investigation",
  selectZoneAdministration: "Select zone administration",
  caseWillBeTransferredToSelectedZonalAdministration:
    "Case will be transferred to the selected zonal administration",
  enterOfficialSummaryOfProsecutorDecision:
    "Enter the official summary of the prosecutor's decision...",
  uploadOfficialDecisionDocument: "Upload Official Decision Document",
  uploadSupportingDocuments: "Upload Supporting Documents",
  fileTypesWithMax10mb: "PDF, DOC, JPG, PNG files (Max 10MB)",
  selectedDocuments: "Selected Documents",
  submitProsecutorDecision: "Submit Prosecutor Decision",
  officialProsecutorialDeterminationNote:
    "This decision will be recorded as an official prosecutorial determination.",
  prosecutorDecisionRecorded: "Prosecutor decision has been formally recorded",
  failedToSubmitProsecutorDecision: "Failed to submit prosecutor decision",
  administrativeReviewDecision: "Administrative Review Decision",
  officialCaseManagementDetermination: "Official Case Management Determination",
  administrativeDetermination: "Administrative Determination",
  selectAdministrativeDecision: "Select administrative decision",
  nextCourseOfActionForCase:
    "This determines the next course of action for this case",
  provideOfficialReasoningForAdministrativeDecision:
    "Provide the official reasoning for this administrative decision...",
  assignInvestigator: "Assign Investigator",
  selectPublicProsecutor: "Select Public Prosecutor",
  assignedProsecutorWillConductOfficialInvestigation:
    "The assigned prosecutor will conduct the official investigation",
  cancelReview: "Cancel Review",
  processingDecision: "Processing Decision...",
  investigatorAssignmentRequiredForApproval:
    "Investigator assignment is required for approval",
  pleaseSelectZoneForForwarding: "Please select a zone for forwarding",
  decisionOfficiallyRecordedInSystem:
    "Decision has been officially recorded in the system",
  failedToProcessAdministrativeDecision:
    "Failed to process the administrative decision",
  forwardToZonalAdministration: "Forward to Zonal Administration",
  forwardToRegionalAdministration: "Forward to Regional Administration",
  approveAndAssignInvestigator: "Approve & Assign Investigator",
  rejectComplaint: "Reject Complaint",
  requestAdditionalInformation: "Request Additional Information",
  forwardToSelectedZone: "Forward to Selected Zone",
  forwardToRegional: "Forward to Regional",
  submitDecision: "murtii galchuu",
  selectDecisionDate: "Please select a decision date",
  provideDecisionSummary: "Please provide a decision summary",
  decisionAddedSuccessfully: "Prosecutor decision added successfully",
  failedToAddDecision: "Failed to add prosecutor decision",
  addProsecutorDecision: "Add Prosecutor Decision",
  characterCount: "Character count",
  chargeFile: "Charge File",
  uploadDecisionDocuments: "Upload Decision Documents",
  selectedFiles: "Selected Files",
  clearAll: "Clear All",
  supportingDocuments: "Supporting Documents",
  optional: "Optional",
  addingDecision: "Adding Decision...",
  addEvidence: "Add Evidence",
  collectedBy: "Collected By",
  collectedByPlaceholder: "Eg. Abebe Kebede",
  evidenceType: "Evidence Type",
  evidenceTypePlaceholder: "Eg. Document",
  collectionDate: "Collection Date",
  remarkPlaceholder: "Provide details...",
  evidenceFiles: "Evidence Files",
  fileTypesSimple: "PDF, JPG, PNG files",
  collectorNameRequired: "Collector name is required",
  evidenceTypeRequired: "Evidence type is required",
  collectionDateRequired: "Collection date is required",
  evidenceSuccessfullyAdded: "Evidence successfully added",
  failedToSubmitEvidence: "Failed to submit evidence",
  selectType: "Select type",
  documentary: "Documentary",
  digital: "Digital",
  physical: "Physical",
  other: "Other",
  addInitialHearingOnChargeDocument: "Add Initial Hearing on Charge Document",
  councilDecision: "Murtii Gumii",
  isCouncilDecideInitialDay: "Is Council Decide Initial Day?",
  letterFileRequired: "Letter file is required",
  createLetter: "Xalayaa Uumuu",
  letterDocument: "Letter Document",
  sendSummonToo: "Send summon too?",
  addDailyHearingFeedback: "Add Daily Hearing Feedback",
  addReporter: "Add Reporter",
  fullName: "Full Name",
  fullNamePlaceholder: "Enter full name",
  phonePlaceholder: "+251-XXX-XXXXXX",
  email: "Emeelii eeruu kennaa",
  emailPlaceholder: "email@example.com",
  address: "Address",
  addressPlaceholder: "Street address",
  locationDetails: "Location Details",
  city: "City",
  idNumber: "ID Number",
  idCard: "ID Card",
  uploadIdCard: "Upload ID Card",
  addSummonDecision: "Add Summon Decision",
  summonLetterNotFound: "Summon Letter not found!",
  uploadResponseFile: "Please upload a response file",
  addVictim: "Add Victim",
  addWitness: "Add Witness",
  registeredRegistrationDate: "Guuyyaa galmeetti galmaa'uu",
  updateMemorandum: "Yaadannoo Haaraa",
  latest: "Latest",
  noChargeDocumentUploaded: "No charge document uploaded",
  councilFeedback: "Council Feedback",
  latestVersion: "Hiika Boodaa",
  noSummaryAvailable: "No summary available",
  noArticleDetailsAvailable: "No article details available",
  documentHistory: "Seenaa galmee",
  previousVersions: "previous versions",
  directorFeedback: "Director Feedback",
  feedbacks: "feedback(s)",
  addDirectorFeedback: "Add Director Feedback",
  successfullyForwardedToProsecutor: "Successfully forwarded to prosecutor",
  forwardToProsecutor: "Forward to Prosecutor",
  councilInitialDecision: "Council Initial Decision",
  initialDecision: "Initial Decision",
  decisionMadeOnInitialDay: "Decision made on initial day",
  initialDayDecision: "Initial Day Decision",
  noDecision: "No Decision",
  rejectCharge: "Reject Charge",
  chargeRejection: "Charge Rejection",
  councilRejectedCharge: "Council rejected the charge",
  rejected: "fudhatama dhabuu",
  rejectionDate: "Rejection Date",
  rejectionReason: "Rejection Reason",
  registerChargeDocument: "Register Charge Document",
  caseStatus: "Case Status",
  currentComplaintStatus: "Haala komii yeroo ammaa",
  accusedLicenseNo: "Accused License No.",
  commissionOfDisciplinaryOffense: "Commission of Disciplinary Offense",
  additionalInformation: "Odeefannoo dabalataa",
  allComplaintDetailsDisplayed: "All complaint details are displayed here",
  terminationDocument: "Ragaa ykn Dokuimantii adda cite",
  officialTerminationDocument: "Official termination document",
  decisionInformation: "Decision Information",
  active: "Hojirra jira",
  latestDecision: "Latest Decision",
  current: "Current",
  outOfJurisdictionSource: "Out of Jurisdiction Source",
  previousDecisions: "Previous Decisions",
  decision: "Murtii",
  collapseAll: "Collapse All",
  expandAll: "Expand All",
  noDecisionsMade: "No decisions have been made yet.",
  evidenceInformation: "Evidence Information",
  supportingEvidenceDocuments: "Supporting evidence documents",
  hearingTimeline: "Hearing Timeline",
  chronologicalRecordOfHearings: "Chronological record of all hearing sessions",
  hearing: "hearing",
  hearings: "hearings",
  hearingSession: "Hearing Session",
  next: "Next",
  order: "Ajaja Gumii",
  noCouncilLitigationData: "No Council Litigation Data",
  noCouncilLitigationMessage:
    "Dhimmichaaf yeroo ammaa galmeen falmii Gumii hin jiru.",
  finalDecisionRenderedByCouncil: "Final decision rendered by the council",
  prosecutorDecisions: "Prosecutor Decisions",
  decisions: "decision(s)",
  notAssignedYet: "Not assigned yet",
  noSummaryProvided: "No summary provided",
  chargeDocuments: "Charge Documents",
  noDecisionsYet: "No Decisions Yet",
  noProsecutorDecisionsMade: "Abbaan alangaa murtii kamiyyuu hin kennine.",
  evidenceDetails: "Evidence Details",
  collectedDate: "Collected Date",
  remarks: "Remarks",
  evidenceFile: "Evidence File",
  noEvidenceAdded: "No Evidence Added",
  addEvidenceToCase: "Add evidence to this case",
  noEvidenceRegistered: "No evidence have been registered for this case",
  unknownCollector: "Unknown Collector",
  noDescriptionProvided: "No description provided",
  evidenceDocuments: "Evidence Documents",
  noReportersAdded: "No Reporters Added",
  addReportersToCase: "Add reporters to this case",
  noReportersRegistered: "No reporters have been registered for this case",
  unnamedReporter: "Unnamed Reporter",
  idDocuments: "ID Documents",
  noVictimsAdded: "No Victims Added",
  addVictimsToCase: "Add victims to this case",
  noVictimsRegistered: "No victims have been registered for this case",
  unnamedVictim: "Unnamed Victim",
  idDocument: "ID Document",
  noWitnessesAdded: "No Witnesses Added",
  addWitnessesToCase: "Add witnesses to this case",
  noWitnessesRegistered: "No witnesses have been registered for this case",
  unnamedWitness: "Unnamed Witness",
  witnessDocuments: "Witness Documents",
  overdue: "Overdue",
  upcoming: "Upcoming",
  scheduled: "Scheduled",
  nextAppointment: "Next Appointment",
  prosecutor: "abbaa alangaa",
  appealDaysRemaining: "guyyoota ol'iyyannoof hafe",
  rejectChargeDocument: "Reject Charge Document",
  comment: "Comment",
  emailAddress: "Email Address",
  completeAddress: "Complete Address",
  regionState: "Region/State",
  cityTown: "City/Town",
  close: "Close",
  reporterFile: "Reporter File",
  reporterInformationRecord: "Reporter Information Record",
  reporterDetails: "Reporter Details",
  notProvided: "Not provided",
  reporterLocation: "Reporter Location",
  identificationDocuments: "Identification Documents",
  reporterIdDocument: "Reporter ID Document",
  pdfDocument: "PDF Document",
  uploaded: "Uploaded",
  recorded: "Recorded",
  lastUpdated: "Last Updated",
  reporterRecord: "Reporter Record",
  officialRecord: "Official Record",
  closeFile: "Close File",
  hearingDatePassed: "Hearing date has passed",
  hearingIsToday: "Hearing is today",
  daysRemaining: "{days} days remaining",
  hearingSummon: "Hearing Summon",
  summonSummary: "Summon Summary",
  officialLetter: "Official Letter",
  summonDocument: "Summon Document",
  confirmSummon: "Confirm Summon",
  officialDocuments: "Official Documents",
  responseLettersAndCorrespondence: "Xalayoota deebii fi walqunnamtiiwwan",
  accusedAdvocateResponse: "Accused Advocate Response",
  officialResponseSubmission: "Official response submission",
  officialSummonLetter: "Official Summon Letter",
  governmentIssuedSummon: "Xalayaa Waamichaa Mootummaan Kenname",
  submitAccusedAdvocateResponse: "Deebii Abukaatoo Himatamaa Galchi",
  summonConfirmationStatus: "Sadarkaa Mirkaneessa Waamichaa",
  overallStatus: "Haala Waliigalaa",
  fullyConfirmed: "Guutummaatti Kan Mirkanaa'e",
  partiallyConfirmed: "Gartuun Kan Mirkanaa'e",
  prosecutorReassignedSuccessfully:
    "Abbaan alangaa milkaa'inaan deebisamee ramadameera",
  failedToReassignProsecutor:
    "Abbaa alangaa deebisanii ramaduun hin danda'amne",
  currentAssignment: "Ramaddii Ammaa",
  currentlyAssignedProsecutor: "Abbaa Alangaa Amma Ramadame",
  noProsecutorAssigned: "Abbaan alangaa ramadame hin jiru",
  pleaseAssignProsecutor: "Maaloo dhimma kanaaf abbaa alangaa ramadi",
  assignNewProsecutor: "Abbaa Alangaa Haaraa Ramadi",
  required: "Barbaachisaa",
  searchProsecutorsPlaceholder: "Abbaantii alangaa maqaan barbaadi...",
  advocateDisciplineProsecutor: "Abbaa Alangaa Naamusaa Abukaatoo",
  selectFromList: "Tarree keessaa filadhu",
  chooseProsecutor: "Abbaa alangaa filadhu...",
  selectedProsecutor: "Abbaa Alangaa Filatame",
  newAssignment: "Ramaddii Haaraa",
  willReplace: "Ni bakka buusa",
  theCurrentAssignment: "ramaddii ammaa",
  note: "Hubachiisa",
  reassignProsecutorNote:
    "Abbaa alangaa haarawa filachuun ramaddii amma jiru bakka buusa.",
  reassigning: "Deebisanii Ramadaa...",
  confirmSubmissionTitle: "Dhiyeessii Mirkaneessi",
  confirmSubmissionMessage:
    "Maaloo odeeffannoo galfame hunda of-eggannoon irra-deebi'ii ilaali. Erga mirkanaa'ee booda gochi kun ni dhiyaata, fooyyessuunis hin danda'amu.",
  search: "Barbaadi",
  noDataAvailable: "Daataan jiru hin jiru.",
  rowsPerPage: "Tarreewwan fuula tokkoof:",
  of: "keessaa",
  page: "Fuula",
  first: "Jalqaba",
  prev: "Duraa",
  last: "Dhuma",
  attachment: "Miila-jalee",
  thisFieldIsRequired: "Dirreen kun barbaachisaadha",
  removeSelectedFile: "Faayila filatame haqi",
  uploadAFileHere: "Faayila asitti olkaa'i",
  downloadFile: "Faayila Buufadhu",
  view: "Ilaali",
  cannotConstructFileUrl: "URL faayilaa ijaaruun hin danda'amne",
  failedToInitializeDocument: "Sanada jalqabsiisuun hin danda'amne",
  emptyFileReceived: "Faayila duwwaatu dhufe",
  unknownError: "Dogongora hin beekamne",
  failedToLoadPdf: "PDF fe'uun hin danda'amne",
  noFileUrlAvailableForDownload: "URL faayilaa buufachuuf dhiyaate hin jiru",
  failedToDownloadFile: "Faayila buufachuun hin danda'amne",
  unknownDocument: "Sanada Hin Beekamne",
  minute: "Daqiiqaa",
  loadingPdf: "PDF fe'aa jira...",
  pdfCouldNotBeLoaded: "PDF fe'amuu hin dandeenye",
  openInNewTab: "Tabii haaraa keessatti bani",
  downloadPdf: "PDF Buufadhu",
  pdfLoadedSuccessfully: "PDF milkaa'inaan fe'ameera",
  noFileUrl: "URL faayilaa hin jiru",
  failedToLoadImage: "Fakkii fe'uun hin danda'amne",
  file: "Faayila",
  unavailable: "Hin jiru",
  download: "Buufadhu",
  created: "Uumameera",
  loadingDocument: "Sanada fe'aa jira...",
  errorLoadingDocument: "Sanada fe'uu irratti dogongorri uumame",
  tryDownloadAnyway: "Ammas buufachuuf yaali",
  failedToLoadVideo: "Viidiyoo fe'uun hin danda'amne",
  browserDoesNotSupportVideo: "Biraawuzeriin kee viidiyoo kana hin deeggaru.",
  failedToLoadAudio: "Odiyoo fe'uun hin danda'amne",
  browserDoesNotSupportAudio: "Biraawuzeriin kee odiyoo kana hin deeggaru.",
  fileCannotBePreviewed:
    "Gosa faayilaa kana biraawuzerii keessatti ilaaluun hin danda'amne. Maaloo ilaaluuf faayilicha buufadhu.",
  closeModal: "Madaalii Cufi",
  updated: "Fooyya'eera",
  type: "Gosa",
  notifications: "Beeksisa",
  unread: "kan hin dubbifamne",
  noNewNotifications: "Beeksisa haaraa hin jiru",
  noNotifications: "Beeksisi hin jiru",
  new: "HAARAWA",
  newNotification: "Beeksisa Haarawa",
  showing: "Agarsiisaa jira",
  menuDashboardSection: "DAASHBORDI",
  menuDashboard: "Daashbordi",
  menuMainTask: "Hojii Ijoo",
  menuReports: "Gabaasota",
  menuProsecutor: "Abbaa Alangaa",
  menuComplaint: "Komii",
  menuAppealedComplaint: "Komii Ol-iyyatame",
  menuAccusedAppeal: "Ol-iyyata Himatamaa",
  menuCourtAppeal: "Ol-iyyata Mana Murtii",
  loadingMenus: "Meenuuwwan fe'aa jira...",
  menuAdvocate: "Abukaatoo",
  menuCompliant: "Komii",
  menuAppealedCompliant: "Komii Ol-iyyatame",
  menuDiscipline: "Naamusaa",
  menuReportByMobile: "Gabaasa Moobaayiliin",
  poweredByEaii: "EAII'n kan deeggarame",
  logout: "Ba'i",
  brandOfficeName: "Biiroo Abbaa Alangaa W.O.",
  brandOfficeNameAm: "የኦሮሚያ ጠቅላይ ዐቃቤ ሕግ ቢሮ",
  uploadClaimFile: "Faayila Himannaa Olkaa'uu",
  upload: "Olkaa'i",
  updateChargeDocument: "Sanada Himannaa Fooyyessi",
  update: "Fooyyessi",
  victimFile: "Faayila Miidhamamaa",
  victimInformationRecord: "Galmee Odeeffannoo Miidhamamaa",
  victimDetails: "Bal'ina Miidhamamaa",
  victimLocation: "Bakka Miidhamamaa",
  victimIdDocument: "Sanada Eenyummaa Miidhamamaa",
  victimRecord: "Galmee Miidhamamaa",
  witnessStatementFile: "Faayila Jecha Dhugaa Baatuu",
  witnessInformationRecord: "Galmee Odeeffannoo Dhugaa Baatuu",
  witnessDetails: "Bal'ina Dhugaa Baatuu",
  witnessLocation: "Bakka Dhugaa Baatuu",
  witnessIdDocument: "Sanada Eenyummaa Dhugaa Baatuu",
  statementRecorded: "Jechi Galmaa'eera",
  witnessStatement: "Jecha Dhugaa Baatuu",
  advocateCourtAppealRequests: "Gaaffii Ol’iyyannoo Mana Murtii Abukaatoo",
  courtAppealDetail: "Bal’ina Ol’iyyannoo Mana Murtii Abukaatoo",
  courtSummonNotFound: "Waamichi Mana Murtii hin argamne!",
  addCourtAppealDailyHearing: "Dhagaha Ol'iyyannoo Mana Murtii Dabaluu",
  reportType: "Gosa Gabaasaa",
  isItFinalDecision: "Murtii Dhumaati?",
  successful: "Milkaa'eera",
  courtAppealSummon: "Waamicha Ol’iyyannoo Mana Murtii",
  appealDocuments: "Ragaalee Ol'iyyannoo",
  noAppealDocumentsUploaded: "Dokumentiin ol'iyyannoo hin fe'amne.",
  courtDetails: "Bal'ina Mana Murtii",
  courtHearingDate: "Guyyaa Dhaddacha Mana Murtii",
  courtOrder: "Ajaja Mana Murtii",
  sendToCoordinator: "Gara Qindeessaa Erguu",
  confirmCourtSummon: "Waamicha Mana Murtii Mirkaneessuu",
  disciplineManagement: "Bulchiinsa Naamusaa",
  baawoSystem: "Sirna B.A.A.W.O.",
  loginTitle: "Seeni",
  authFormInstruction:
    "Maaloo adeemsa hojii guyyaa keetii jalqabuuf unka kana of-eggannoon guuti, erga teessoo argattee booda ni mirkanaa'a",
  emailLabel: "Emeelii",
  passwordLabel: "Jecha Icctii",
  passwordPlaceholder: "Jecha icctii kee galchi",
  newPasswordLabel: "Jecha Icctii Haarawa",
  newPasswordPlaceholder: "Jecha icctii haarawa galchi",
  confirmPasswordLabel: "Jecha Icctii Mirkaneessi",
  confirmPasswordPlaceholder: "Jecha icctii kee galchi",
  registerAccountTitle: "Akkaawuntii Galmeessi",
  loading: "Fe'aa jira...",
  loginButton: "Seeni",
  registerButton: "Galmeessi",
  invalidEmailOrPassword: "Emeelii ykn jecha icctii dogongoraa",
  loginOfficeName: "Waajjira Abbaa Alangaa Ummataa",
  loginOfficeAddress: "Odeeffannoo Teessoo",
  dontHaveAccount: "Akkaawuntii hin qabduu?",
  alreadyHaveAccount: "Akkaawuntii qabduu?",
  incidentListTitle: "Tarree Taateewwan",
  incidentCaseColumn: "Dhimma",
  incidentTypeColumn: "Gosa",
  incidentStatusColumn: "Sadarkaa",
  incidentDateColumn: "Guyyaa",
  incidentTypeRobbery: "Hattummaa",
  incidentTypeFraud: "Gowwoomsaa",
  incidentTypeAssault: "Miidhaa Qaamaa",
  incidentInformationTab: "Odeeffannoo Taateewwan",
  evidenceFilesTab: "Faayilota Ragaa",
  suspectTab: "Shakkamaa",
  victimsTab: "Miidhamtoota",
  witnessesTab: "Dhugaa Baatota",
  exhibitsTab: "Imaanaawwan",
  screeningTab: "Sifannoo",
  incidentDetailsInformationTitle: "Odeeffannoo Bal'ina Taateewwan",
  incidentDetailsPlaceholder: "Bal'inni taatee asitti galfama...",
  incidentReportDate: "Guyyaa Gabaasa Taatee",
  incidentDate: "Guyyaa Taatee",
  crimeCategoryLabel: "Ramaddii Yakkaa",
  receptionMethodLabel: "Mala Simannaa",
  regionLabel: "Naannoo",
  addressLabel: "Teessoo",
  incidentReportedBy: "Taatee Kan Gabaase",
  reporterAgeEducationCountry: "Waggaa 54 • Diigrii • Itoophiyaa",
  crimeNarrativeInfo: "Odeeffannoo Seenaa Yakkaa",
  evidenceOne: "Ragaa tokko",
  evidenceTwo: "Ragaa lama",
  crimeInformationTitle: "Odeeffannoo Yakkaa",
  suspectsListLabel: "Tarree Shakkamtootaa",
  suspectsListDesc: "Namoota 2 • Guyyaa dhumaa itti fooyya'e",
  victimListLabel: "Tarree Miidhamtootaa",
  victimListDesc: "Miidhamtoota 2 • Lachu • Guyyaa dhumaa itti fooyya'e",
  evidenceListLabel: "Tarree Ragaalee",
  evidenceListDesc: "Meeshaalee 3 • PDF • Yeroo dhumaaf fooyya'e",
  exhibitItemsListLabel: "Tarree Meeshaalee Imaanaa",
  exhibitItemsListDesc: "Meeshaalee 2 • Faayilota Doc • Yeroo dhumaaf fooyya'e",
  respondBackButton: "Deebii Kenni",
  approveButton: "Mirkaneessi",
  dashboardOverviewTitle: "Waliigala",
  dashboardOverviewDescription:
    "Hojiiwwan adeemsa abbaa alangaa keessatti hojjetaman hordofuu, tajaajiloota ariifachiisoo dhiyeessuu fi adeemsa bulchiinsa dhimmoota gurguddoo bakka tokkotti hordofuu.",
  dashboardActiveScopes: "ijaarsa hojii",
  dashboardPriorityQueues: "tajaajiloota dursa argatan",
  dashboardUpcomingMilestones: "milkaawwan dhufan",
  dashboardOperationalSnapshot: "Hubannoo hojii",
  dashboardPriorityQueuesTitle: "Tajaajiloota dursa argatan",
  dashboardPriorityQueuesDescription:
    "Iddoowwan xiyyeeffannoo hatattamaa qindeessitoota, qabeenyootaa fi abbootii alangaa.",
  dashboardStatusCritical: "ariifachiisaa",
  dashboardStatusAttention: "xiyyeeffannoo",
  dashboardStatusStable: "tasgabbaa'aa",
  dashboardProjectScopeCoverage: "Haguuggii pirojeektii",
  dashboardWorkloadAcrossModules:
    "Ba'aa hojii mooduloota abbaa alangaa gurguddoo keessatti",
  dashboardScopes: "hojiiwwan",
  dashboardTotal: "waliigala",
  dashboardInProgress: "Adeemsarra jira",
  dashboardOpenModule: "Moodulii bani",
  complainantName: "Maqaa Komataa",
  complainantPhone: "Bilbila Komataa",
  accusedProsecutorName: "Maqaa Abbaa Alangaa Himatame",
  disciplineReportByMobile: "Gabaasa Naamusaa Moobaayiliin",
  disciplineReportTable: "← Gabatee Gabaasa Naamusaa",
  courtAppealRequests: "Gaaffii Ol'iyyata Mana Murtii",
  registerCouncilAttendanceTitle:
    "Galmee Hirmaannaa Abbaa Alangaa Komataa fi Himatamaa",
  namePlaceholder: "Maqaa asitti...",
  appealRequests: "Gaaffii Ol'iyyataa",
  updateDate: "Guyyaa Fooyya'e",
  prosecutorDecisionSummary: "Cuunfaa Murtii Abbaa Alangaa",
  addEvaluation: "Madaallii Dabaluu",
  evaluationDate: "Guyyaa Madaallii",
  viewEvaluation: "Madaallii Ilaali",
  submitAccusedResponse: "Deebii Ofiisaa Galchi",

  evaluation: "Madaallii",
  workSpeedEvaluation: "Madaallii Ariitii Hojii",
  workQualityEvaluation: "Madaallii Qulqullina Hojii",
  workLoadEvaluation: "Madaallii Ba'aa Hojii",
  noEvaluationsFound: "Madaalliin argame hin jiru",

  reload: "Deebisanii fe'uu",
  // Prosecutor discipline dashboard
  pdDashboardTitle: "Daashboordii",
  pdWelcomeBack: "Baga nagaan dhuftan",
  pdOverviewAssigned: "Waliigala dhimmoota naamusaa isiniif ramadamanii.",
  pdOverviewUnit: "Waliigala dhimmoota naamusaa abbaa alangaa caasaa bulchiinsa keessan keessaa.",
  pdOverviewAll: "Waliigala dhimmoota naamusaa abbaa alangaa isin arguu dandeessanii.",
  pdScopeAll: "Caasaalee bulchiinsaa hunda",
  pdScopeAssigned: "Dhimmoota naaf ramadaman",
  pdScopeUnit: "Caasaa bulchiinsaa",
  pdRangeAll: "Yeroo hunda",
  pdRange7: "Guyyoota 7 darban",
  pdRange30: "Guyyoota 30 darban",
  pdRange90: "Guyyoota 90 darban",
  pdRangeYear: "Bara kana",
  pdRangeCustom: "Yeroo filatame",
  pdFrom: "Irraa",
  pdTo: "Hanga",
  pdRefresh: "Haaromsi",
  pdLoading: "Fe'aa jira...",
  pdTotalCases: "Dhimmoota waliigalaa",
  pdTotalCasesHint: "Dhimmoota yeroo kana keessaa hunda",
  pdFromPrevious: "yeroo darbe irraa",
  pdOfTotal: "dhimmoota hunda keessaa",
  pdYourQueue: "Tarree keessan",
  pdStageReceived: "Kan fudhataman",
  pdStageReceivedHint: "Haaraa, kan deebi'an ykn odeeffannoo eegan",
  pdStageInvestigation: "Qorannoo jala",
  pdStageInvestigationHint: "Kan ramadaman, qorannoo ykn himannaa qopheessaa jiran",
  pdStageCouncil: "Gumii irra",
  pdStageCouncilHint: "Waamicha, paanaalii, falmii fi murtii",
  pdStageAppeal: "Kan ol'iyyataman",
  pdStageClosed: "Kan cufaman",
  pdStageClosedHint: "Kan cufaman, xumuraman, addaan citan ykn kufan",
  pdStageOther: "Kan biroo",
  pdSummons: "Waamicha kenname",
  pdCasesByStage: "Dhimmoota sadarkaan",
  pdCaseTrend: "Adeemsa dhimmootaa",
  pdLast6Months: "(ji'oota 6 darban)",
  pdByOffence: "Dhimmoota gosa yakkaan",
  pdByDecision: "Murtiiwwan",
  pdUpcomingHearings: "Dhaggeeffannaa dhufan (guyyoota 30)",
  pdRecentCases: "Dhimmoota dhiyoo",
  pdViewAll: "Hunda ilaali",
  pdNoData: "Yeroo kanaaf odeeffannoon hin jiru",
  pdNoHearings: "Guyyoota 30 dhufan keessatti dhaggeeffannaan hin jiru",
  pdNoRoleDashboard: "Gahee keessaniif daashboordiin naamusa abbaa alangaa hin jiru.",
  pdLoadFailed: "Odeeffannoo daashboordii fe'uun hin danda'amne",
};

export default or;
